export class UserData {
    constructor() {
        this.stamps = Array();
    }
}
